import React, { useState } from 'react';
import { Diff, X } from 'lucide-react';
import dayjs from 'dayjs';

export default function TransactionModal({
  date,
  me,
  dispatch,
  actions,
  banks,
  fetchData,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const [listPayment, setListPayment] = useState('');
  const [amount, setAmount] = useState('');
  const [selectedBank, setSelectedBank] = useState('');

  const handleTransaction = async (type) => {
    if (!amount || !listPayment) return;

    const payload = {
      date: dayjs(date).format('YYYY-MM-DD'),
      paymentlist: listPayment,
      amount: parseFloat(amount),
      typeTansaction: type,
      user: {
        id: me?.userData._id,
        firstname: me?.userData?.firstname,
        lastname: me?.userData?.lastname,
      },
    };
    if (banks && selectedBank) {
      payload.bankId = selectedBank;
    }

    await dispatch(actions.paymentOtherCreate(payload));
    setAmount('');
    setListPayment('');
    fetchData();
    setIsOpen(false);
  };

  // ตรวจสอบว่ามี bank หรือไม่
  const hasBanks = banks && banks.length > 0;

  return (
    <>
      {/* Trigger Button */}
      <button
        className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        onClick={() => setIsOpen(true)}
      >
        <Diff size={20} className="mr-2" />
        รายรับ/รายจ่าย
      </button>

      {/* Modal Overlay */}
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-5xl w-full max-h-[90vh] overflow-y-auto">
            {/* Modal Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200">
              <h2 className="text-2xl font-bold text-gray-900">
                รายรับ/รายจ่าย
              </h2>
              <button
                onClick={() => setIsOpen(false)}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors"
              >
                <X size={24} className="text-gray-500" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-8">
              <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                {/* ชื่อทำรายการ */}
                <div className={hasBanks ? 'lg:col-span-5' : 'lg:col-span-6'}>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    ชื่อทำรายการ
                  </label>
                  <input
                    type="text"
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg"
                    value={listPayment}
                    onChange={(e) => setListPayment(e.target.value)}
                    placeholder="กรอกชื่อทำรายการ"
                  />
                </div>

                {/* จำนวนเงิน */}
                <div className={hasBanks ? 'lg:col-span-4' : 'lg:col-span-6'}>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    จำนวนเงิน (บาท)
                  </label>
                  <input
                    type="number"
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    placeholder="0.00"
                  />
                </div>

                {/* ธนาคาร - แสดงเฉพาะเมื่อมี banks */}
                {hasBanks && (
                  <div className="lg:col-span-3">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      เลือกช่องทางการชำระเงิน
                    </label>
                    <select
                      className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg"
                      value={selectedBank}
                      onChange={(e) => setSelectedBank(e.target.value)}
                    >
                      <option value="">เลือกช่องทางการชำระเงิน"</option>
                      {banks.map((bank) => (
                        <option
                          key={bank._id || bank.id}
                          value={bank._id || bank.id}
                        >
                          {bank.bankName ?? bank.name ?? '-'}
                        </option>
                      ))}
                    </select>
                  </div>
                )}

                {/* ปุ่มเพิ่ม/ถอน */}
                <div className="lg:col-span-12 flex flex-col sm:flex-row gap-4 mt-4">
                  <button
                    onClick={() => handleTransaction('รายรับ')}
                    className="flex-1 px-6 py-3 bg-green-600 hover:bg-green-700 text-white rounded-lg font-semibold transition-colors shadow-md"
                  >
                    รายรับ
                  </button>
                  <button
                    onClick={() => handleTransaction('รายจ่าย')}
                    className="flex-1 px-6 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-semibold transition-colors shadow-md"
                  >
                    รายจ่าย
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
